import React from "react";

function BlockingLoader() {
    return <div id="form-app">
        <div className="loader-overlay">
            <div className="loader-container">
                <svg className="circular-loader" viewBox="25 25 50 50">
                    <circle
                        className="loader-path"
                        cx="50"
                        cy="50"
                        r="20"
                        fill="none"
                        strokeWidth="4"
                        strokeDasharray="150, 200"
                        strokeDashoffset="-10"
                        stroke="#0265FF"
                    />
                </svg>
            </div>
        </div>
    </div>;
}

export default BlockingLoader;
